const SectionsLoader = () => {
  return (
    <div className="mb-4 grid grid-cols-12 gap-4">
      <div className="col-span-12 rounded-xl bg-white p-6 shadow-lg">
        <div className="mb-4 flex items-center justify-between border-b border-gray-200 pb-4">
          <div className="h-6 w-48 animate-pulse rounded-lg bg-gray-200"></div>
          <div className="h-4 w-20 animate-pulse rounded-lg bg-gray-200"></div>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
          {[...Array(6)].map((_, index) => (
            <div
              key={index}
              className="flex h-[12rem] flex-col rounded-xl border border-gray-200 bg-white p-2 text-center shadow-sm lg:h-[16.5rem]"
            >
              <div className="flex-1 animate-pulse overflow-hidden rounded-t-lg bg-gray-300"></div>
              <div className="mx-auto mt-2 h-4 w-3/4 animate-pulse rounded-lg bg-gray-200"></div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-span-12 rounded-xl bg-white p-6 shadow-lg md:col-span-4">
        <div className="mb-4 flex items-center justify-between border-b border-gray-200 pb-4">
          <div className="h-6 w-48 animate-pulse rounded-lg bg-gray-200"></div>
          <div className="h-4 w-20 animate-pulse rounded-lg bg-gray-200"></div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-2">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="flex h-[12rem] flex-col rounded-xl border border-gray-200 bg-white p-2 text-center shadow-sm lg:h-[16.5rem]"
            >
              <div className="flex-1 animate-pulse overflow-hidden rounded-t-lg bg-gray-300"></div>
              <div className="mx-auto mt-2 h-4 w-3/4 animate-pulse rounded-lg bg-gray-200"></div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-span-12 rounded-xl bg-white p-6 shadow-lg md:col-span-4">
        <div className="mb-4 flex items-center justify-between border-b border-gray-200 pb-4">
          <div className="h-6 w-48 animate-pulse rounded-lg bg-gray-200"></div>
          <div className="h-4 w-20 animate-pulse rounded-lg bg-gray-200"></div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-2">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="flex h-[12rem] flex-col rounded-xl border border-gray-200 bg-white p-2 text-center shadow-sm lg:h-[16.5rem]"
            >
              <div className="flex-1 animate-pulse overflow-hidden rounded-t-lg bg-gray-300"></div>
              <div className="mx-auto mt-2 h-4 w-3/4 animate-pulse rounded-lg bg-gray-200"></div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-span-12 animate-pulse rounded-xl bg-gray-300 p-6 shadow-lg md:col-span-4"></div>
    </div>
  );
};

export default SectionsLoader;
